import { createContext, createElement, useContext, type ReactNode } from "react"
import { useParams, useSearchParams } from "next/navigation"

const BookIdContext = createContext<string | undefined>(undefined)

export function BookIdProvider({ bookId, children }: { bookId?: string; children: ReactNode }) {
  return createElement(BookIdContext.Provider, { value: bookId }, children)
}

export function useBookId() {
  const contextBookId = useContext(BookIdContext)
  const params = useParams()
  const searchParams = useSearchParams()
  return contextBookId ?? (params?.bookId as string) ?? searchParams.get("bookId") ?? undefined
}
